import { FiChevronDown } from "react-icons/fi";
import { ImWindows8 } from "react-icons/im";
import { SiApple } from "react-icons/si";
import { RiInformationFill } from "react-icons/ri"
import "./DownloadButton.css";
import { useEffect, useState } from "react";
import minervaIcon from '../../medias/images/minerva-icon-24.png'
import { requestGetCurrentTrackerVersion } from "../../services/wisdomServices/desktopAppService";

/**
 * @function DownloadButton
 * @returns {JSX.Element} - download button component
 */
function DownloadButton() {  
  const [appVersion, setAppVersion] = useState('')

  const getAppVersion = async () => {
    let version = await requestGetCurrentTrackerVersion()
    setAppVersion(version.version)
  }
  useEffect( () => {
   getAppVersion()
  }, [])

  return (
    <div className="download-toggle-option" id='step-2'>
      <div className="downloadbutton">
        <span>Downloads</span> <FiChevronDown />
      </div>
      <div className="download-options">
        <div className="download-option">
          <a href={`https://github.com/SiriusSupportDevTeam/wisdom-tracker/releases/download/v${appVersion}/Wisdom-Tracker-${appVersion}.exe`}>
            <ImWindows8 size={"24px"}/> <span>Windows</span>
          </a>
        </div>
        <div className="download-option">
          <a href={`https://github.com/SiriusSupportDevTeam/wisdom-tracker/releases/download/v${appVersion}/Wisdom-Tracker-${appVersion}.dmg`}>
            <SiApple size={"24px"}/> <span>MacOS</span>
          </a>
        </div>
        <div className="download-option">
          <a href={`https://github.com/SiriusSupportDevTeam/wisdom-tracker/releases/download/v${appVersion}/Wisdom-Tracker-Guide.pdf`}>
            <RiInformationFill size={"24px"}/> <span>User Guide</span>
          </a>
        </div>
      </div>
    </div>
  );
}
export default DownloadButton;
